import React from 'react';
import { graphql, useFragment } from 'react-relay';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import {
	PACKAGE_NAME,
	TEAM_NAME,
} from '@jira/navigation-apps__atlassian-navigation-nav4-common/src/common/constants.tsx';
import Skeleton from '@atlaskit/skeleton';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import type { ProductHomeWithQuery$key } from './__generated__/ProductHomeWithQuery.graphql';
import { ProductHome } from './main.tsx';

export const ProductHomeWithQuery = ({
	queryReference,
}: {
	queryReference: ProductHomeWithQuery$key;
}): React.JSX.Element => (
	<JSErrorBoundary
		id="Nav4TopNavProductHomeRelay"
		packageName={PACKAGE_NAME}
		teamName={TEAM_NAME}
		fallback="unmount"
	>
		<Placeholder
			name="nav4-top-nav-product-home-relay"
			fallback={<Skeleton isShimmering width="100px" height="20px" />}
		>
			<Content queryReference={queryReference} />
		</Placeholder>
	</JSErrorBoundary>
);

function Content({
	queryReference,
}: {
	queryReference: ProductHomeWithQuery$key;
}): React.JSX.Element {
	// eslint-disable-next-line @atlassian/relay/use-fragment-naming, @atlassian/relay/use-fragment-naming
	const data = useFragment(
		graphql`
			fragment ProductHomeWithQuery on Query {
				jira {
					issueByKey(key: $issueKey, cloudId: $cloudId)
						@include(if: $shouldCheckProjectTypeForIssue) {
						projectField {
							project {
								projectType
							}
						}
					}
					jiraProjectByKey(key: $projectKey, cloudId: $cloudId)
						@include(if: $shouldCheckProjectType) {
						projectType
					}
				}
			}
		`,
		// eslint-disable-next-line @atlassian/relay/use-fragment-naming
		queryReference,
	);

	const issueProjectType =
		data?.jira?.jiraProjectByKey?.projectType ??
		data?.jira?.issueByKey?.projectField?.project?.projectType;

	return <ProductHome projectType={issueProjectType} />;
}
